export default "__VITE_ASSET__CeiOTZWK__"